import type { ComponentType } from "react";
import { Tooltip } from "@mui/material";
import { capitalize } from "es-toolkit/string";
import { MetricGroupIcon } from "src/business-components/metrics/MetricGroupTypeWithIcon/MetricGroupTypeWithIcon";
import type { Metrics } from "src/business-components/PipelineSummary/PipelineSummary.types";

interface PipelineSummaryMetricsGroupProps {
  appName: string;
  metrics: [string, Metrics][];
  Comp: ComponentType<any>;
}

const PipelineSummaryMetricsGroup = ({
  appName,
  metrics,
  Comp,
}: PipelineSummaryMetricsGroupProps) => (
  <div className="flex flex-col gap-1">
    {metrics.map(([name, value]) => {
      return (
        <div key={name}>
          <Tooltip
            arrow
            disableInteractive
            placement="left"
            title={
              capitalize(name) +
              ("count" in value && value.count === null ? " N/A" : "")
            }
            className="inline-flex items-center gap-4"
          >
            <div>
              <MetricGroupIcon
                type={name}
                iconSX={{
                  color: ({ palette }) => palette.neutral.main,
                  fontSize: "16px",
                }}
              />
              <div className="grid h-5 place-items-center">
                <Comp value={value} pipelineName={appName} />
              </div>
            </div>
          </Tooltip>
        </div>
      );
    })}
  </div>
);

export default PipelineSummaryMetricsGroup;
